<template>
    <div class="main-container">
        <h3>Upload Previous Payslip and It sheets</h3>
        <div>
          <div class="option-container">
            <tl-select
              class="content-width"
              label="Payment Year*"
              name="paymentYear"
              v-model="paymentYear"
              :multiple="false"
              :options="paymentYearList"
              @change="(val)=>paymentYear = val"
              data-vv-as="Payment Year"
              v-validate="{required: true}"
              :classname="errors.has('paymentYear')"
              :errormsg="errors.first('paymentYear')"
            />
            <tl-select
              class="content-width"
              label="Payment Month*"
              name="paymentMonth"
              v-model="paymentMonth"
              :multiple="false"
              :options="paymentMonthList"
              @change="(val)=>paymentMonth = val"
              data-vv-as="Payment Month"
              v-validate="{required: true}"
              :classname="errors.has('paymentMonth')"
              :errormsg="errors.first('paymentMonth')"
            />
            <tl-select
              class="content-width"
              label="Document Type*"
              name="documentType"
              v-model="documentType"
              labelText="name"
              :multiple="false"
              :options="docTypeList"
              @change="(val)=>documentType = val"
              data-vv-as="Document Type"
              v-validate="{required: true}"
              :classname="errors.has('documentType')"
              :errormsg="errors.first('documentType')"
            />
          </div>
          <div  class="option-container">
            <div class="content-width">
              <div class="download-btn-container">
                <img src="@/assets/download.svg"  class="img" />
                <a class="text" href="https://payliefprod-client-logos.s3.ap-south-1.amazonaws.com/previous_payslip_itSheet.xlsx">Download Template</a>
              </div>
              <p style="font-weight: 500; font-size: 0.9rem;">Upload Excel File</p>
              <upload :maxSize="10485800" :tobucket="false" name="bulkExcelFile"  @change="onUploadExcelTemplate($event)"></upload>
              <p style="color: #FF0000;font-weight: 500;margin-top:10px;">Note: Zip File Should be less than 10Mb</p>
            </div>
            <div class="content-width">
              <p style="font-weight: 500; font-size: 0.9rem;margin-top: 24px;">Upload Zip File</p>
              <upload :maxSize="104858000" :tobucket="false" name="bulkZipFile"  @change="onUploadZipTemplate($event)"></upload>
              <p style="color: #FF0000;font-weight: 500;margin-top:10px;">Note: Zip File Should be less than 100Mb</p>
            </div>
            <button class="mt-2 mb-2 customButton"  @click="upload">Upload</button>
          </div>
          <div class="table-container">
            <button class="refresh" @click="refreshData">Refresh</button>
            <data-table 
              :columns="uploadColumnNames" 
              :tableData="uploadDataDetails"
              :checkbox="false"
              :withForm="false"
              :showhistory="false"
              :showedit="false"
              :showdelete="false"
            >
            <template v-slot:rowcontent="slotprops">
              <p
                v-if="
                  slotprops.value.column.key != 'type' &&
                  slotprops.value.column.key != 'download'"
              >
                {{ slotprops.value.record[slotprops.value.column.key] }}
              </p>
              <div class="text-capital" v-if="slotprops.value.column.key == 'type'">
                <span>{{ fileTypeEnums[slotprops.value.record.type] }}</span>
              </div>
              <p class="download-icon" @click="downloadUrl(slotprops.value.record)" v-if="slotprops.value.column.key == 'download'">
                <img src="@/assets/DownloadEss.svg" alt="">
                <span>Download Logs</span>
              </p>
            </template>
          </data-table>
          </div>
        </div>
        <pop-up-message
          v-if="showErrorPopup"
          :message="`Upload is Processing`"
          btnText="OK"
          @back="gotoBack()"
        ></pop-up-message>
    <toast-message
      :message="errmsg"
      type="error"
      :isToastEnable="toast"
      @close="(val) => toast = val"
    />
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
export default {
  data(){
    return{
      employeeLopData:[],
      toast:false,
      errmsg:'',
      paymentYear: '',
      paymentMonth: '',
      documentType: null,
      excel_file: '',
      zip_file: '',
      fileTypeEnums: {
        paySlip: "Payslip",
        ITSheet: "IT sheet"
      },
      docTypeList: [{name:"Payslip", value: "paySlip"}, {name:"IT sheet", value: "ITSheet"},{name:"Additional Payslip", value: "additional_paySlip"}],
      tabs: [{
          header: 'Update LOP & RLOP'
        },
        {
          header: 'Employees List'
        }
      ],
      paymentYearList: [],
      paymentMonthList: ['January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'],
      showErrorPopup: false,
      logSheetUrl: null,
      uploadColumnNames: [
        { 
          label: "File Type",
          key: "type"
        },
        {
          label: "File Name",
          key: "file_name"
        },
        {
          label: "Status",
          key: "status"
        },
        {
          label: "Download Log Details",
          key: "download"
        }
      ],
      uploadDataDetails: []
    }
  },
  mounted(){
    const today = new Date();
    const currentYear = today.getFullYear();
    const previousFiveYears = [];
    for (let i = 0; i < 5; i++) {
      previousFiveYears.push(currentYear - i);
    }
    this.paymentYearList = previousFiveYears;
    this.getUploadPyaslipsLogs();
  },
  activated(){
    
  },
  computed: {
    ...mapState({
      entities: state => state.onboard.legal_entities.data
    }),

    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID"
    }),
    le_id() {
      if (this.$route.params.entity_index)
        return this.getleid(this.$route.params.entity_index);
      else return this.getleid(0);
    }
  },
  methods:{
    ...mapActions({
      act_upload_previous_payslip_itsheet: "dashboard/organisation/utilities/itsheetandpayslip/uploadPreviousPayslipItsheet",
      act_get_upload_logs: "dashboard/organisation/utilities/itsheetandpayslip/getUploadPreviousPayslipItsheetLogs",
      act_get_upload_logs_presigned_url: "dashboard/organisation/utilities/itsheetandpayslip/getLogsPresignedUrl"
    }),

    onUploadExcelTemplate(event){
      this.excel_file = event;
    },

    onUploadZipTemplate(event){
      this.zip_file = event;
    },

    async upload() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.performAction();
        }
      })
    },

    gotoBack(){
      this.showErrorPopup = false;
      this.getUploadPyaslipsLogs();
    },

    async downloadUrl(item){
      try {
        let res = await this.act_get_upload_logs_presigned_url(item.Id);
        if(res && res.data && res.data.data){
          const link = document.createElement("a");
          link.href = res.data.data;
          // link.setAttribute("download", "salaryRevisionTemplate"+ ".xlsx"); //or any other extension
          document.body.appendChild(link);
          link.click();
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    refreshData(){
      this.getUploadPyaslipsLogs();
    },

    async getUploadPyaslipsLogs(){
      try {
        let res = await this.act_get_upload_logs(this.le_id);
        if(res && res.data && res.data.data){
          this.uploadDataDetails = res.data.data;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    async performAction(){
      let clientCode =  this.entities[this.$route.params.entity_index] ? this.entities[this.$route.params.entity_index].clientCode : null;
      let month = this.paymentMonth.toLowerCase();
      let formData = new FormData();
      formData.append("file1", this.excel_file);
      formData.append("file2", this.zip_file);
      formData.append("paymentYear", this.paymentYear);
      formData.append("paymentMonth", month);
      formData.append("legalEntityId", this.le_id);
      formData.append("clientCode", clientCode);
      formData.append("documentType", this.documentType.value);

      try {
        let res = await this.act_upload_previous_payslip_itsheet(formData); 
        if(res && res.data && res.data.status){
          this.showErrorPopup = true;
          this.logSheetUrl = res.data.data
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    }
  }
  
}
</script>

<style scoped lang="scss">
  .option-container{
    display: flex;
    align-items: center;
    gap: 15px;
    width: 100%;
    margin-top: 20px;
  }

.customButton{
  display: block;
  border-radius: 4px;
  background-color: #5d409f;
  color: #ffffff;
  font-weight: bold;
  width:18%;
  min-height: 45px;
  padding: 14px;
  transition: all 0.5s ease;
}

.customButton:hover{
  opacity: 0.8;
}

.content-width{
  min-width: 20%;
}

.table-container{
  margin-top: 50px;
  display: flex;
  flex-direction: column;
  align-items: end;
}

.refresh{
  background-color: #5d409f;
  color: #ffffff;
  font-weight: 500;
  border-radius: 4px;
  padding: 8px 18px;
  margin-bottom: 10px;
  transition: all 0.5s ease;
}

.refresh:hover{
  opacity: 0.8;
}

.download-icon{
  display: flex; 
  align-items: center; 
  gap: 10px; 
  cursor: pointer;
}
.download-btn-container {
  display: flex;
  align-items: normal;
  .img {
    height: 18px;
    width: 16px;
    object-fit: contain;
  }
  .text {
    font-size: 14px;
    font-weight: 600;
    margin-left: 8px;
    margin-bottom: 10px;
    cursor: pointer;
  }
}
</style>
